module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }